import { Avatar }                           from "@/components/ui/avatar";
import { Box }                              from "@chakra-ui/react";
import { Button }                           from '@/components/ui/button';
import DeleteProfilePictureModal            from "../modals/DeleteProfilePictureModal";
import EditIcon                             from '@/assets/icons/EditIcon';
import { FileUploadRoot }                   from "@/components/ui/file-button";
import { FileUploadTrigger }                from "@/components/ui/file-button";
import { Image }                            from '@chakra-ui/react';
import { Text }                             from '@chakra-ui/react';
import authStore                            from "@/stores/authStore";
import { observer }                         from "mobx-react";
import { useTranslation }                   from "react-i18next";

interface IProfilePictureContainerProps {
	setProfilePictureModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setCropperModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setNewProfilePicture: React.Dispatch<React.SetStateAction<File | undefined>>;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfilePictureContainer = observer((props: IProfilePictureContainerProps) => {
	const { setProfilePictureModalIsOpen, setCropperModalIsOpen, setNewProfilePicture, setIsLoading } = props;
	const currentUser = authStore.currentUser;
	const { t } = useTranslation();
	const currentUserHasProfilePicture = !!currentUser.userMediaProfilePicture;
	
	return (
		<Box
			display="flex"
			alignItems="center"
		>
			{
				currentUserHasProfilePicture ?
				<Image 
					height="140px" 
					width="100px"
					src={currentUser.userMediaProfilePicture} 
					rounded="md"
					shadow="md"
				/>
				:
				<Avatar
					width="100px"
					height="100px"
					bg="defaultBackground"
					variant="outline"
					name={currentUser.fullName}
					src={currentUser.userMediaProfilePicture}
					shadow="lg"
				/>
			}
			<Box
				paddingLeft="20px"
				height="140px"
			>
				<Box
					display="flex"
					flexDirection="column"
					justifyContent={{ base: "space-between", lg: "unset" }}
					height="100%"
					gap="7px"
				>
					<Text
						className='poppins-semibold'
						fontSize="18px"
					>
						{t('pages.personalInformation.personalInformationBox.photo')}
					</Text>
					<Box
						display="flex"
						alignItems="center"
						gap="10px"
						flexWrap={{ base: "wrap", lg: "nowrap" }}
						width="100%"
					>
						<FileUploadRoot 
							alignItems="stretch" 
							maxFiles={1}
							hideFrom="lg"
							accept={["image/jpeg", "image/png"]}
							onFileAccept={(fileAcceptDetails) => {
								const { files } = fileAcceptDetails;
								const file = files[0];
								setNewProfilePicture(file);
								setProfilePictureModalIsOpen(false);
								setCropperModalIsOpen(true)
							}}
						>	
							<FileUploadTrigger 
								asChild
							>
								<Button 
									variant={"outline"} 
									width={{ base: "100%", lg: "fit-content" }}
									fontSize="14px"
									textWrap="wrap"
								>
									<EditIcon />
									{t('pages.personalInformation.personalInformationBox.form.actions.edit')}
								</Button>
							</FileUploadTrigger>
						</FileUploadRoot>
						<Button 
							fontSize="14px"
							hideBelow="lg"
							textWrap="wrap"
							variant={"outline"} 
							width={{ base: "100%", lg: "fit-content" }}
							onClick={() => setProfilePictureModalIsOpen(true)}
						>
							<EditIcon />
							{t('pages.personalInformation.personalInformationBox.form.actions.edit')}
						</Button>
						<DeleteProfilePictureModal setIsLoading={setIsLoading} />
					</Box>
				</Box>
			</Box>
		</Box>
	)
})

export default ProfilePictureContainer;